import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';
import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import { ScrollRestoration } from "react-router-dom"


const navigation = [ 
    { id: 1, name: 'Nos recommandations', to: '/strategie-retraite/' , icon: ArrowLongDownIcon},
    { id: 2, name: 'Bilans retraite', to: '/bilan-retraite/' , icon: ArrowLongDownIcon},
    { id: 4, name: 'Des solutions d\'optimisation', to: '/solutions-optimisation/' , icon: ArrowLongDownIcon},
    { id: 5, name: 'Etudes comparatives expatriation', to: '/retour-expatriation/' , icon: ArrowLongDownIcon},
    { id: 6, name: 'Des conférences spécifiques', to: '/nos-conferences/' , icon: ArrowLongDownIcon},
    { id: 7, name: 'Liquidations de retraite', to: '/liquidations-retraite/' , icon: ArrowLongDownIcon},
]

const context = [
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Analyse approfondie de votre situation :</h3>,
        "core": [
            {
                "subtitle": <span className='font-bold'> Délais de carence:</span>,
                "text": <span> nous calculons la durée de votre délai de carence en prenant en compte les éléments spécifiques à votre situation ( congés payés, montant de l'indemnité supra-légale,...</span>,
            },
            {
                "subtitle": <span className='font-bold'> Période indemnisée: </span>,
                "text": <span>nous évaluons cette durée d'indemnisation</span>,
            },
            {
                "subtitle": <span className='font-bold'> Période non indemnisée: </span>,
                "text": <span>nous vous informations des implications d'une période de chômage non indemnisée sur vos droits à la retraite.</span>
            }
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Validation de trimestres :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous estimons les trimestress "assimilés" qui peuvent être validés pendant ces périodes de chômage. </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Validation de points AGIRC-ARRCO :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous estimons les points AGIRC-ARRCO qui sont attribués pendant les périodes de chômage indemnisé. </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Estimation de l'Aide au Retour à l'Emploi (ARE) :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous estimons le montant dde votre indemnisation en fonction de la législation en vigueur. </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Impact sur les bilans retraite :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous tenons compte de l'ensemble des paramètres chômage précités pour établir vos bilans retraite. </span>,
            },            
        ]
    }
]

export default function Articulation() {   

    return (
        <>

            <Title classNames="bg-articulation bg-cover lg:bg-right bg-left" title="Articulation chômage/retraite" />

            <Subtitle subtitle="Comprendre le passage du chômage en fin de carrière à la retraite" paragraph="Notre service d'accompagnement dédié vous apporte un éclairage sur cette transition vers la retraite." />      

            <Core navigation={navigation} context={context} />

            <Footer />

            <ScrollRestoration />
        </>
    )
}